<template>
	<div class="h-100">
		<Shimmer :gridView="true" v-if="loaderStatus" />
		<section
			class="h-100 d-flex align-items-center flex-column justify-content-center"
			v-else-if="!assets.length"
		>
			<template
				v-if="!assets.length && !searchQuery && $route.name === 'assetbank'"
			>
				<section
					class="w-100 h-100 d-flex justify-content-center align-items-center flex-column"
				>
					<img src="@/assets/asset-bank/noassetsadded.svg" />
					<span class="no-data-txt mt-3 ml-3 text-center"
						>No {{ tabText }} have been added,<br />
						click "+ file" button to upload the {{ tabText }}s
					</span>

					<PButton
						class="mt-3 ml-3"
						:type="'add'"
						text="File"
						@clicked="$emit('openModal')"
					/>
				</section>
			</template>
			<template
				v-else-if="
					(!assets.length && searchQuery) ||
					(!assets.length && !searchQuery && $route.name !== 'assetbank')
				"
			>
				<img src="@/assets/common/no-data-found.svg" alt="" />
				<p
					class="fs-14 fw-500 font-secondary fc-black"
					v-if="!assets.length && searchQuery"
				>
					No matching results
					<span v-if="searchQuery"> for"{{ searchQuery }}" </span>
				</p>
				<p
					class="fs-14 fw-500 font-secondary fc-black"
					v-if="!assets.length && !searchQuery && $route.name !== 'assetbank'"
				>
					No Data Found
				</p>
			</template>
		</section>
		<div
			v-else-if="assets && assets.length && !loaderStatus"
			class="cards-container"
			:class="{
				'overflow-auto asset-bank-height': $route.name == 'assetbank',
			}"
		>
			<!-- <div v-if="assets.length"> -->

			<div
				v-for="(asset, index) in assets"
				:key="index"
				:class="{ 'asset-card-selection': selectedAssetID == asset.assetID }"
				class="asset-card position-relative pointer"
				@click.stop="
					$route.name === 'coursecreation'
						? ((hideView = false), selectAsset(asset))
						: handleAssetClick(asset, index)
				"
			>
				<div class="d-flex justify-content-between align-items-center">
					<!-- LEFT: Thumbnail + Text -->
					<section
						class="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden"
					>
						<!-- Thumbnail -->
						<article class="flex-shrink-0">
							<div class="position-relative img-dim">
								<img
									v-if="asset.assetThumbnail"
									class="overlap-img"
									src="@/assets/asset-bank/video-play-img.svg"
								/>
								<img
									class="grid-img-dim"
									v-if="asset.assetType == '1' && asset.assetThumbnail"
									style="border-radius: 4px"
									:src="asset.assetThumbnail"
								/>
								<img
									class="grid-img-dim"
									v-else-if="asset.assetType == '1' && !asset.assetThumbnail"
									style="border-radius: 4px"
									src="@/assets/asset-bank/grid-no-thumbnail.svg"
								/>
								<img
									v-else-if="asset.assetType == '2'"
									style="border-radius: 4px"
									src="@/assets/asset-bank/grid-ppt.svg"
									width="90px"
								/>
								<img
								v-else-if="asset.assetType == '8'"
								style="border-radius: 4px"
								src="@/assets/asset-bank/grid-zip.svg"
							/>
								<img
									class="grid-img-dim"
									v-if="asset.assetType == '3'"
									style="border-radius: 4px"
									:src="asset.asset"
								/>
								<img
									v-if="asset.assetType == '4'"
									style="border-radius: 4px"
									src="@/assets/asset-bank/grid-pdf.svg"
									width="90px"
									height="57px"
								/>
								<img
									v-if="asset.assetType == '5'"
									style="border-radius: 4px"
									src="@/assets/asset-bank/grid-card-notes.svg"
								/>
								<img
									v-if="asset.assetType == '6'"
									style="border-radius: 4px"
									src="@/assets/asset-bank/grid-link.svg"
								/>
							</div>
						</article>

						<!-- Text (filename + size) -->
						<article class="flex-grow-1 d-flex flex-column overflow-hidden">
							<div
								class="filename text-truncate mt-1"
								:id="'tooltipname-file' + index"
								style="width: fit-content; max-width: 100%"
							>
								{{ asset.title }}
							</div>

							<b-tooltip
								:target="'tooltipname-file' + index"
								placement="bottom"
								boundary="window"
								triggers="hover focus"
								custom-class="custom-tooltip-unique"
								:delay="{ show: 200, hide: 200 }"
							>
								<span class="tooltip-content">
									{{ asset.title }}
								</span>
							</b-tooltip>

							<div class="filesize mt-1">
								{{ asset.assetSize.actualSize }}
							</div>
						</article>
					</section>

					<!-- RIGHT: Menu -->
					<article class="flex-shrink-0">
						<div
							class="d-flex justify-content-end align-items-center"
							@click.stop=""
						>
							<div
								class="menu-dots-wrapper"
								@click.stop="assetID = asset.assetID"
							>
								<img src="@/assets/common/menu-dots.svg" alt="menu dots" />
							</div>

							<!-- <div class="ab-menu-grid" v-if="!isCreation">
        <img class="ab-menu-grid" src="@/assets/common/menu-dots.svg"
             @click.stop="assetID = asset.assetID" />
        <img class="ab-menu-grid-hover" src="@/assets/asset-bank/hover-icon.svg"
             @click.stop="assetID = asset.assetID" />
      </div>
      <div class="ab-menu-grid" v-else>
        <img @click="(hideView = true), handleAssetClick(asset, index)"
             src="@/assets/asset-bank/gridview-view-icon.svg" />
      </div> -->
						</div>

						<!-- Asset Actions -->
						<div
							v-if="assetID == asset.assetID"
							class="ab-menu-icons icons-align"
							@click.stop=""
						>
							<img
								@click.stop="editOrViewAsset(asset, index)"
								src="@/assets/asset-bank/asset-edit.svg"
								class=""
							/>
							<img
								@click.stop="(showDelete = true), (showDetails = asset)"
								class=""
								src="@/assets/asset-bank/asset-delete.svg"
							/>
							<img
								class=" "
								src="@/assets/asset-bank/asset-close.svg"
								@click.stop="assetID = null"
							/>
						</div>
					</article>
				</div>
				<!-- </div> -->
			</div>

			<!-- space left below for pagination -->
			<ViewLink
				v-if="viewLink"
				:editAsset="editAsset"
				:viewLink="viewLink"
				:showDetails="showDetails"
				:validation="$v.showDetails"
				@changeVal="changeVal"
				@closeModal="closeModal"
				@handle-save="saveEditedAsset('viewLink')"
				:loading="showLoader"
			/>
			<ViewFile
				v-if="viewFile"
				@handle-get="getMethod"
				@getThumbnail="getThumbnail"
				:viewFile="viewFile"
				:showDetails="showDetails"
				:validation="$v.showDetails"
				@deleteFile="deleteFile"
				:editFile="editFile"
				@closeModal="closeModal"
				@fileUploaded="fileUploaded"
				:thumbnailPresent="thumbnailPresent"
				@changeVal="changeVal"
				@handle-save="saveEditedAsset('viewFile')"
				:errorFile="errorFile"
				:loading="showLoader"
			/>
			<DeleteModal
				:loading="showLoader"
				@handle-delete="deleteAsset('showDelete')"
				:showDelete="showDelete"
				@closeModal="closeModal"
				:headtext="'Delete'"
				:summarytext="'Are you sure you want to delete the item?'"
			/>
			<ViewImage
				v-if="viewImage"
				@handle-get="getMethod"
				:viewImage="viewImage"
				:showDetails="showDetails"
				:validation="$v.showDetails"
				:editImage="editImage"
				@changeVal="changeVal"
				@closeModal="closeModal"
				:loading="showLoader"
				@fileUploaded="fileUploaded"
				:errorFile="errorFile"
				@handle-save="saveEditedAsset('viewImage')"
			/>
			<ViewNotes
				v-if="viewNotes"
				:viewNotes="viewNotes"
				:showDetails="showDetails"
				:validation="$v.showDetails"
				:editNotes="editNotes"
				:loading="showLoader"
				@changeVal="changeVal"
				@closeModal="closeModal"
				@handle-save="saveEditedAsset('viewNotes')"
			/>
		</div>
		<div v-if="showlazyLoading" class="d-flex justify-content-center">
			<b-spinner label="Loading..."></b-spinner>
		</div>
	</div>
</template>

<script>
import assetMixins from "@/views/asset-bank/mixins/assetMixins";

export default {
	name: "GridView",
	mixins: [assetMixins],
	data() {
		return {
			gridView: true,
			loopVar: 100,
			showMenu: false,
			assetID: null,
		};
	},
	created() {
		this.selectedAssetID = this.selectedAsset?.assetID;
	},
	props: {
		assets: Array,
		selectedAsset: Object,
	},
};
</script>

<style>
.ab-menu-grid-hover {
	display: none;
}
.ab-menu-grid:hover .ab-menu-grid-hover {
	display: block;
}
.ab-menu-grid:hover .ab-menu-grid {
	display: none;
}
.ab-menu-icons {
	position: absolute;
	top: 15px;
	padding: 3px 12px 4px 12px;
	right: 8px;
	background: var(--color-white);
	border: 1px solid rgba(140, 140, 140, 0.15);
	box-shadow: 0px 4px 5px 1px rgba(111, 111, 111, 0.17);
	border-radius: 22px;
	z-index: 10;
}
.cards-container {
	grid-template-columns: repeat(auto-fill, minmax(315px, 1fr));
	padding: 10px 30px;
	display: grid;
	grid-template-rows: repeat(auto-fill, minmax(70px, 1fr));
	grid-gap: 12px 15px;
}
.asset-bank-height {
	height: calc(100vh - 312px);
}
.gap-15px {
	gap: 15px;
}
.asset-card {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	height: 67px;
	padding: 5px;
}
.asset-card-selection {
	background: #e1eef7;
}
.card-img {
	border-radius: 4px;
}
.filename {
	font-family: "Lato";
	font-weight: var(--weight-400);
	font-size: 15px;
	color: #20639b;
	max-width: 230px;
	/* height: 51%; */
}
.filesize {
	font-family: "Lato";
	font-weight: var(--weight-400);
	font-size: var(--size-13);
	color: #333333;
}
.asset-card .col-2 {
	max-width: 13.666667%;
}
.grid-img-dim {
	height: 57px;
	width: 90px;
}
.overlap-img {
	position: absolute;
	left: 0x;
	top: 4px;
}
.img-dim {
	height: 57px;
	width: 90px;
}
.img-dim img {
	width: 100%;
	height: 100%;
}
.menu-dots-wrapper {
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background 0.3s ease;
}

.menu-dots-wrapper:hover {
	background: rgba(32, 99, 155, 1);
}

.menu-dots-wrapper:hover img {
	filter: brightness(0) invert(1); /* Makes SVG white if it's black or dark */
}
.icons-align {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	height: 32px;
	cursor: auto;
}
.icons-align img {
	cursor: pointer;
}
</style>
